import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { WebApiService } from './webapi.service';
import { ICustomer, IPayment, ILedger } from '../components/Customer/customer.class';

@Injectable()
export class CustomerService {
    private headers = new Headers({ 'Content-Type': 'application/json' });
    private userUrl = 'api/User';  // URL to web api

    constructor(private http: Http, private webApi: WebApiService) { }

    getUser(): Promise<ICustomer> {
        return this.webApi.get(this.userUrl + '/GetCurrentuser');
    }

    updateCustomer(customer: ICustomer): Promise<any> {
        return this.webApi.put(this.userUrl + '/UpdateCustomer', customer);
    }

    authenticated(): Promise<boolean> {
        return this.http.get(this.userUrl + 'Authenticated')
            .toPromise()
            .then(response => {
                const dbg = response.json();
                return dbg.authenticated;
            })
            .catch(this.handleError);
    }

    login(username: string, password: string): Promise<any> {
        const params: string = 'grant_type=password&username=' + username + '&password=' + password;
        return this.http.post(WebApiService.serverUrl + 'token', params)
            .toPromise()
            .then(response => {
                const dbg = response.json();
                localStorage.setItem('token', JSON.stringify(dbg.access_token));
                this.getUser()
                    .then((cust) => {
                        const usr: ICustomer = cust;
                        localStorage.setItem('user', JSON.stringify(usr));
                    });
                return response;
            })
            .catch(this.handleError);
    }

    getCustomers(): Promise<ICustomer[]> {
        return this.webApi.get(this.userUrl + '/GetCustomers');
    }

    getCustomerLedger(customerId: number): Promise<ILedger[]> {
        return this.webApi.get(this.userUrl + '/GetCustomerLedger' + '?customerId=' + customerId);
    }

    deleteCustomer(customer: ICustomer)
    {
        return this.webApi.post(this.userUrl + '/DeleteCustomer', { customerId: customer.customerId });
    }

    addPayment(payment: IPayment): Promise<ICustomer> {
        return this.webApi.put(this.userUrl + '/AddPayment', payment);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/customer.service.ts